import { render } from "./EditPRModal.vue?vue&type=template&id=c1bfd59e"
import script from "./EditPRModal.vue?vue&type=script&lang=js"
export * from "./EditPRModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__